import { Alert, FormControl, InputLabel, MenuItem, Select, Snackbar, TextField, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { authTypeOptions, autoOffsetTypeOptions, booleanTypeOptions } from '../../../constants/constantList';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { api } from '../../../redux/api';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import { stringifyJSONAttributes, stringToBooleanConversion, decryptString, encryptString } from '../../../utils/utilFunctions';
import _ from 'lodash';

const Kafka = ({ connectionDetails, handleBodyContent, direction, account, screen, disableControl, repoPDC, useConnection, source = "" }) => {
    const shouldEncryptDecryptPassword = String(source || "").toLowerCase() !== "pdc";
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [topicName, setTopicName] = useState('');
    const [bootstrapServers, setBootstrapServers] = useState('');
    const [groupId, setGroupId] = useState('');
    const [keyDeSerial, setKeyDeSerial] = useState('');
    const [valueDeSerial, setValueDeSerial] = useState('');
    const [clientId, setClientId] = useState('');
    const [keySerial, setKeySerial] = useState('');
    const [valueSerial, setValueSerial] = useState('');
    const [autoCommit, setAutoCommit] = useState('');
    const [offsetReset, setOffsetReset] = useState('');
    const [pollRecords, setPollRecords] = useState('');
    const [outTime, setOutTime] = useState('');
    const [authType, setAuthType] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [sslVersion, setSslVersion] = useState('');
    const [keyStore, setKeyStore] = useState('');
    const [keyStorePassword, setKeyStorePassword] = useState('');
    const [keyPassword, setKeyPassword] = useState('');
    const [trustStore, setTrustStore] = useState('');
    const [trustStorePassword, settrustStorePassword] = useState('');
    const [sslVersionsTypeOptions, setSslVersionsTypeOptions] = useState([]);
    const [content, setContent] = useState(null);
    const [workflowSessionModal, setWorkflowSessionModal] = useState({open: false, isFirstTime: false});
    const [valueLabel, setValueLabel] = useState("");

    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });

    const handleAlertClose = () => {
        setShowAlert({ ...showAlert, isOpen: false });
    } 

    const keyDeSerialTypeOptions = [
        { text: t('STRING_DESERIALIZER'), value: t('STRING_DESERIALIZER') }
    ];

    const valueDeSerialTypeOptions = [
        { text: t('STRING_DESERIALIZER'), value: t('STRING_DESERIALIZER') }
    ];

    const keySerialTypeOptions = [
        { text: 'ByteArraySerializer', value: 'ByteArraySerializer' },
        { text: 'StringSerializer', value: 'StringSerializer' }
    ];

    const valueSerialTypeOptions = [
        { text: 'ByteArraySerializer', value: 'ByteArraySerializer' },
        { text: 'StringSerializer', value: 'StringSerializer' }
    ];

    const removeUndefinedAndNullKeys = (obj = {}) => {
        const tempObj = {...obj}
        Object.keys(tempObj || {}).forEach(e => {
            if(tempObj[e] === undefined || tempObj[e] === null) delete tempObj[e];
        })
        return tempObj
    }

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    const onInputChange = (name, value) => {
        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
            if (name === "PASSWORD" || name === "KEYSTORE_PWD"  || name === "TRUSTSTORE_PWD") {
                setContent((prev) => {
                    return {[name]: name === "PASSWORD" && !shouldEncryptDecryptPassword ? value : encryptString(value, process.env.REACT_APP_SECRET_KEY2) };
                });
            } else {
                setContent((prev) => {
                    return {[name]: value };
                });
            }
        } else {
            setContent((prev) => {
                return { ...prev, [name]: value };
            });
        }
    };

    useEffect(() => {
        setTopicName(connectionDetails?.TOPIC_NAME || '');
        setBootstrapServers(connectionDetails?.BOOTSTRAP_SERVERS_CONFIG || '');
        setGroupId(connectionDetails?.GROUP_ID_CONFIG || 'e5b9ca6c-5b4b-41ec-aadb-e67df6faabed');
        setKeyDeSerial(connectionDetails?.KEY_DESERIALIZER_CLASS_CONFIG || 'StringDeserializer');
        setValueDeSerial(connectionDetails?.VALUE_DESERIALIZER_CLASS_CONFIG || 'StringDeserializer');
        // Destination
        setClientId(connectionDetails?.CLIENT_ID_CONFIG || '');
        setKeySerial(connectionDetails?.KEY_SERIALIZER_CLASS_CONFIG || 'StringSerializer');
        setValueSerial(connectionDetails?.VALUE_SERIALIZER_CLASS_CONFIG || 'StringSerializer');
        setOffsetReset(connectionDetails?.AUTO_OFFSET_RESET_CONFIG || 'earliest');
        setAutoCommit(connectionDetails?.ENABLE_AUTO_COMMIT_CONFIG || 'FALSE');
        setPollRecords(connectionDetails?.MAX_POLL_RECORDS_CONFIG || 1);
        setOutTime(connectionDetails?.TIMEOUT || '');
        setAuthType(connectionDetails?.AUTH_TYPE || 'NONE');
        setUsername(connectionDetails?.USERNAME || '');
        
        // Handle password decryption for GET_DATA and SEND_DATA
        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
            setPassword(
                shouldEncryptDecryptPassword
                    ? decryptString(
                        (connectionDetails?.PASSWORD || ""),
                        process.env.REACT_APP_SECRET_KEY2
                    ) || ''
                    : (connectionDetails?.PASSWORD || '')
            );
            setKeyStorePassword(
                decryptString(
                    (connectionDetails?.KEYSTORE_PWD || ""),
                    process.env.REACT_APP_SECRET_KEY2
                ) || ''
            );
            setKeyPassword(connectionDetails?.KEY_PWD || "");
            settrustStorePassword(
                decryptString(
                    (connectionDetails?.TRUSTSTORE_PWD || ""),
                    process.env.REACT_APP_SECRET_KEY2
                ) || ''
            );
        } else {
            setPassword(connectionDetails?.PASSWORD || '');
            setKeyStorePassword(connectionDetails?.KEYSTORE_PWD || '');
            setKeyPassword(connectionDetails?.KEY_PWD || '');
            settrustStorePassword(connectionDetails?.TRUSTSTORE_PWD || '');
        }
        
        setSslVersion(connectionDetails?.SSL_TYPE || 'TLSv1');
        setKeyStore(connectionDetails?.KEYSTORE || '');
        setTrustStore(connectionDetails?.TRUSTSTORE || '');
        setContent({ ...connectionDetails })
    }, [connectionDetails]);

    useEffect(() => {
        dispatch(api.endpoints.getSslVersion.initiate({ account, adapterType: 'kafka' })).then((res) => {
            if (res?.data?.current_state === 'SUCCESS') {
                setSslVersionsTypeOptions(res?.data?.data);
            }
            if (res?.data?.current_state === 'ERROR') {
                setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
            }
        })
    }, []);

    useEffect(() => {
        if(!_.isEqual(removeUndefinedAndNullKeys(content), removeUndefinedAndNullKeys(connectionDetails))) {
            debouncedContentUpdate(content);
        }
    }, [content]);

    const getFontWeight = (control, currentValue, useConnection) => {
        if (!repoPDC) return "normal";
        return repoPDC?.[control] !== currentValue &&
            useConnection === "preDefined"
            ? "bold"
            : "normal";
    };

    const fontWeights = {
        topicName: getFontWeight("TOPIC_NAME", topicName, useConnection),
        bootstrapServers: getFontWeight("BOOTSTRAP_SERVERS_CONFIG", bootstrapServers, useConnection),
        groupId: getFontWeight("GROUP_ID_CONFIG", groupId, useConnection),
        keyDeSerial: getFontWeight("KEY_DESERIALIZER_CLASS_CONFIG", keyDeSerial, useConnection),
        valueDeSerial: getFontWeight("VALUE_DESERIALIZER_CLASS_CONFIG", valueDeSerial, useConnection),
        autoCommit: getFontWeight("ENABLE_AUTO_COMMIT_CONFIG", autoCommit, useConnection),
        offsetReset: getFontWeight("AUTO_OFFSET_RESET_CONFIG", offsetReset, useConnection),
        outTime: getFontWeight("TIMEOUT", outTime, useConnection),
        clientId: getFontWeight("CLIENT_ID_CONFIG", clientId, useConnection),
        keySerial: getFontWeight("KEY_SERIALIZER_CLASS_CONFIG", keySerial, useConnection),
        valueSerial: getFontWeight("VALUE_SERIALIZER_CLASS_CONFIG", valueSerial, useConnection),
        authType: getFontWeight("AUTH_TYPE", authType, useConnection),
        username: getFontWeight("USERNAME", username, useConnection),
        password: getFontWeight("PASSWORD", password, useConnection),
        sslVersion: getFontWeight("SSL_TYPE", sslVersion, useConnection),
        keyStore: getFontWeight("KEYSTORE", keyStore, useConnection),
        keyStorePassword: getFontWeight("KEYSTORE_PWD", keyStorePassword, useConnection),
        keyPassword: getFontWeight("KEY_PWD", keyPassword, useConnection),
        trustStore: getFontWeight("TRUSTSTORE", trustStore, useConnection),
        trustStorePassword: getFontWeight("TRUSTSTORE_PWD", trustStorePassword, useConnection)
    };

    return (
        <>
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_TOPIC_NAME")}
                        type="text"
                        value={topicName}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setTopicName(e.target.value);
                        }}
                        className={"width-100"}
                        name={"TOPIC_NAME"}
                        autoComplete="off"
                        inputProps={{
                            style: { fontWeight: fontWeights.topicName }
                        }}
                    />
                </FormControl>
                {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                    <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                            setValueLabel(t("LBL_TOPIC_NAME"));
                            setWorkflowSessionModal({ open: true, isFirstTime: true });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                    </Button>
                )}
            </div>
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_BOOTSTRAP_SERVERS_CONFIG")}
                        type="text"
                        value={bootstrapServers}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setBootstrapServers(e.target.value);
                        }}
                        className={"width-100"}
                        name={"BOOTSTRAP_SERVERS_CONFIG"}
                        autoComplete="off"
                        inputProps={{
                            style: { fontWeight: fontWeights.bootstrapServers }
                        }}
                    />
                </FormControl>
                {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                    <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                            setValueLabel(t("LBL_BOOTSTRAP_SERVERS_CONFIG"));
                            setWorkflowSessionModal({ open: true, isFirstTime: true });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                    </Button>
                )}
            </div>
            {direction === 'IN' && <>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_MESSAGE_GROUP_ID")}
                            type="text"
                            value={groupId}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setGroupId(e.target.value);
                            }}
                            className={"width-100"}
                            name={"GROUP_ID_CONFIG"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.groupId }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_MESSAGE_GROUP_ID"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="keyDeSerialTypeDropdownLabel">
                        {t("LBL_KEY_DESERIALIZER_CLASS_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"KEY_DESERIALIZER_CLASS_CONFIG"}
                        labelId="keyDeSerialTypeDropdownLabel"
                        label={t("LBL_KEY_DESERIALIZER_CLASS_CONFIG")}
                        id="keyDeSerialTypeDropdown"
                        value={keyDeSerial || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setKeyDeSerial(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.keyDeSerial } }}
                    >
                        {
                            keyDeSerialTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={obj.value}>
                                    {obj.text}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="valueDeSerialTypeDropdownLabel">
                        {t("LBL_VALUE_DESERIALIZER_CLASS_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"VALUE_DESERIALIZER_CLASS_CONFIG"}
                        labelId="valueDeSerialTypeDropdownLabel"
                        label={t("LBL_VALUE_DESERIALIZER_CLASS_CONFIG")}
                        id="valueDeSerialTypeDropdown"
                        value={valueDeSerial || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setValueDeSerial(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.valueDeSerial } }}
                    >
                        {
                            valueDeSerialTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={obj.value}>
                                    {obj.text}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="autoCommitTypeDropdownLabel">
                        {t("LBL_ENABLE_AUTO_COMMIT_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"ENABLE_AUTO_COMMIT_CONFIG"}
                        labelId="autoCommitTypeDropdownLabel"
                        label={t("LBL_ENABLE_AUTO_COMMIT_CONFIG")}
                        id="autoCommitTypeDropdown"
                        value={autoCommit || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setAutoCommit(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.autoCommit } }}
                    >
                        {
                            booleanTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={obj.value}>
                                    {t(obj.text)}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="autoOffsetTypeDropdownLabel">
                        {t("LBL_AUTO_OFFSET_RESET_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"AUTO_OFFSET_RESET_CONFIG"}
                        labelId="autoOffsetTypeDropdownLabel"
                        label={t("LBL_AUTO_OFFSET_RESET_CONFIG")}
                        id="autoOffsetTypeDropdown"
                        value={offsetReset || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setOffsetReset(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.offsetReset } }}
                    >
                        {
                            autoOffsetTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={t(obj.value)}>
                                    {t(obj.text)}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={true}
                            label={t("LBL_MAX_POLL_RECORDS_CONFIG")}
                            type="text"
                            value={pollRecords || 0}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setPollRecords(e.target.value);
                            }}
                            className={"width-100"}
                            name={"MAX_POLL_RECORDS_CONFIG"}
                            autoComplete="off"
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || true}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_MAX_POLL_RECORDS_CONFIG"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_TIMEOUT")}
                            type="text"
                            value={outTime}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                const numericValue = inputValue.replace(/\D/g, '');
                                if (numericValue.length <= 9) {
                                    setOutTime(numericValue);
                                    onInputChange(e.target.name, numericValue);
                                }
                            }}
                            className={"width-100"}
                            name={"TIMEOUT"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.outTime }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_TIMEOUT"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
            </>}
            {direction === 'OUT' && <>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_CLIENT_ID_CONFIG")}
                            type="text"
                            value={clientId}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setClientId(e.target.value);
                            }}
                            className={"width-100"}
                            name={"CLIENT_ID_CONFIG"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.clientId }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_CLIENT_ID_CONFIG"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="keySerialTypeDropdownLabel">
                        {t("LBL_KEY_SERIALIZER_CLASS_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"KEY_SERIALIZER_CLASS_CONFIG"}
                        labelId="keySerialTypeDropdownLabel"
                        label={t("LBL_KEY_SERIALIZER_CLASS_CONFIG")}
                        id="keyDeSerialTypeDropdown"
                        value={keySerial || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setKeySerial(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.keySerial } }}
                    >
                        {
                            keySerialTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={obj.value}>
                                    {obj.text}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
                <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                    <InputLabel id="valueSerialTypeDropdownLabel">
                        {t("LBL_VALUE_SERIALIZER_CLASS_CONFIG")}
                    </InputLabel>
                    <Select
                        className={"width-100"}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                        name={"VALUE_SERIALIZER_CLASS_CONFIG"}
                        labelId="valueSerialTypeDropdownLabel"
                        label={t("LBL_VALUE_SERIALIZER_CLASS_CONFIG")}
                        id="valueSerialTypeDropdown"
                        value={valueSerial || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setValueSerial(e.target.value);
                        }}
                        disabled={disableControl || false}
                        sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.valueSerial } }}
                    >
                        {
                            valueSerialTypeOptions.map((obj, key) => (
                                <MenuItem key={key} value={obj.value}>
                                    {obj.text}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </>}
            <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                <InputLabel id="authTypeDropdownLabel">
                    {t("AUTH_TYPE")}
                </InputLabel>
                <Select
                    className={"width-100"}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 300,
                            },
                        },
                    }}
                    name={"AUTH_TYPE"}
                    labelId="authTypeDropdownLabel"
                    label={t("AUTH_TYPE")}
                    id="authTypeDropdown"
                    value={authType || ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onInputChange(e.target.name, value);
                        setAuthType(value);
                        if (value !== t('SASL_PLAIN')) {
                            if(!["SEND_DATA", "GET_DATA"].includes(screen))  onInputChange('USERNAME', '');
                            setUsername('');
                            if(!["SEND_DATA", "GET_DATA"].includes(screen)) onInputChange('PASSWORD', '');
                            setPassword('');
                        }
                        if (value !== t('SSL')) {
                            if(!["SEND_DATA", "GET_DATA"].includes(screen)) onInputChange('KEYSTORE', '');
                            setKeyStore('');
                            if(!["SEND_DATA", "GET_DATA"].includes(screen)) onInputChange('KEYSTORE_PWD', '');
                            setKeyStorePassword('');
                            if(!["SEND_DATA", "GET_DATA"].includes(screen)) onInputChange('KEY_PWD', '');
                            setKeyPassword('');
                        }
                    }}
                    disabled={disableControl || false}
                    sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.authType } }}
                >
                    {
                        authTypeOptions.map((obj, key) => (
                            <MenuItem key={key} value={obj.value}>
                                {t(obj.text)}
                            </MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
            {authType === t('SASL_PLAIN') && <>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_USERNAME")}
                            type="text"
                            value={username || ''}
                            onChange={(e) => {
                                onInputChange('USERNAME', e.target.value);
                                setUsername(e.target.value);
                            }}
                            className={"width-100"}
                            name={"USER_NAME"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.username }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_USERNAME"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>

                <div style={{display:'flex', gap:'4px'}}>
                    <SmartPasswordField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_WS_PASSWORD")}
                        value={password || ''}
                        onChange={(e) => {
                            onInputChange('PASSWORD', e.target.value);
                            setPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"PASS_WORD"}
                        autoComplete="off"
                        sx={{ input: { fontWeight: fontWeights.password } }}
                    />
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_WS_PASSWORD"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>

            </>}
            <FormControl variant="outlined" className="width-100" size="small" disabled={disableControl || false}>
                <InputLabel id="sslTypeDropdownLabel">
                    {t("LBL_SSL_TYPE")}
                </InputLabel>
                <Select
                    className={"width-100"}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 300,
                            },
                        },
                    }}
                    name={"SSL_TYPE"}
                    labelId="sslTypeDropdownLabel"
                    label={t("LBL_SSL_TYPE")}
                    id="sslTypeDropdown"
                    value={sslVersion || ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onInputChange(e.target.name, value);
                        setSslVersion(value);
                        if (value === 'NONE') {
                            onInputChange('TRUSTSTORE', '');
                            setTrustStore('');
                            onInputChange('TRUSTSTORE_PWD', '');
                            settrustStorePassword('');
                        }
                    }}
                    disabled={disableControl || false}
                    sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.sslVersion } }}
                >
                    {
                        sslVersionsTypeOptions.map((obj, key) => (
                            <MenuItem key={key} value={obj}>
                                {obj}
                            </MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
            {authType === t('SSL') && <>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_KEYSTORE")}
                            type="text"
                            value={keyStore || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setKeyStore(e.target.value);
                            }}
                            className={"width-100"}
                            name={"KEYSTORE"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.keyStore }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_KEYSTORE"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <div style={{display:'flex', gap:'4px'}}>
                    <SmartPasswordField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_KEYSTORE_PASSWORD")}
                        value={keyStorePassword || ''}
                        onChange={(e) => {
                            onInputChange('KEYSTORE_PWD', e.target.value);
                            setKeyStorePassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"KEYSTORE_PWD"}
                        autoComplete="off"
                        sx={{ input: { fontWeight: fontWeights.keyStorePassword } }}
                    />
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_KEYSTORE_PASSWORD"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <div style={{display:'flex', gap:'4px'}}>
                    <SmartPasswordField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_KEY_PASSWORD")}
                        value={keyPassword || ''}
                        onChange={(e) => {
                            onInputChange('KEY_PWD', e.target.value);
                            setKeyPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"KEY_PWD"}
                        autoComplete="off"
                        sx={{ input: { fontWeight: fontWeights.keyPassword } }}
                    />
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_KEY_PASSWORD"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
            </>}
            {sslVersion !== t('NONE') && <>
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("TRUSTSTORE")}
                            type="text"
                            value={trustStore || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setTrustStore(e.target.value);
                            }}
                            className={"width-100"}
                            name={"TRUSTSTORE"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.trustStore }
                            }}
                        />
                    </FormControl>
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("TRUSTSTORE"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
                <div style={{display:'flex', gap:'4px'}}>
                    <SmartPasswordField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_TRUSTSTORE_PASSWORD")}
                        value={trustStorePassword || ''}
                        onChange={(e) => {
                            onInputChange('TRUSTSTORE_PWD', e.target.value);
                            settrustStorePassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"TRUSTSTORE_PWD"}
                        autoComplete="off"
                        sx={{ input: { fontWeight: fontWeights.trustStorePassword } }}
                    />
                    {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                        <Button
                            size="small"
                            disabled={disableControl || false}
                            variant="outlined"
                            onClick={() => {
                                setValueLabel(t("LBL_TRUSTSTORE_PASSWORD"));
                                setWorkflowSessionModal({ open: true, isFirstTime: true });
                            }}
                            sx={{ width: "40px", minWidth: "40px" }}>
                            <MoreHorizOutlined fontSize="small" />
                        </Button>
                    )}
                </div>
            </>}
            <WorkflowSessionModal
                valueLabel={valueLabel}
                showAccountData={true}
                showCallingWorkflow={true}
                showSystemData={true}
                showWorkflowSession={true}
                showDateAndTime={true}
                openModal={workflowSessionModal}
                setModalOpen={setWorkflowSessionModal}
                handleClose={() =>
                    setWorkflowSessionModal({ open: false, isFirstTime: false })
                }
                initialValue={
                    valueLabel === t("LBL_TOPIC_NAME")
                        ? topicName
                        : valueLabel === t("LBL_BOOTSTRAP_SERVERS_CONFIG")
                        ? bootstrapServers
                        : valueLabel === t("LBL_MESSAGE_GROUP_ID")
                        ? groupId
                        : valueLabel === t("LBL_CLIENT_ID_CONFIG")
                        ? clientId
                        : valueLabel === t("LBL_MAX_POLL_RECORDS_CONFIG")
                        ? pollRecords
                        : valueLabel === t("LBL_TIMEOUT")
                        ? outTime
                        : valueLabel === t("LBL_USERNAME")
                        ? username
                        : valueLabel === t("LBL_WS_PASSWORD")
                        ? password
                        : valueLabel === t("LBL_KEYSTORE")
                        ? keyStore
                        : valueLabel === t("LBL_KEYSTORE_PASSWORD")
                        ? keyStorePassword
                        : valueLabel === t("LBL_KEY_PASSWORD")
                        ? keyPassword
                        : valueLabel === t("TRUSTSTORE")
                        ? trustStore
                        : valueLabel === t("LBL_TRUSTSTORE_PASSWORD")
                        ? trustStorePassword
                        : ""
                }
                valuesHandler={(value) => {
                    if (valueLabel === t("LBL_TOPIC_NAME")) {
                        onInputChange("TOPIC_NAME", value);
                        setTopicName(value);
                    } else if (valueLabel === t("LBL_BOOTSTRAP_SERVERS_CONFIG")) {
                        onInputChange("BOOTSTRAP_SERVERS_CONFIG", value);
                        setBootstrapServers(value);
                    } else if (valueLabel === t("LBL_MESSAGE_GROUP_ID")) {
                        onInputChange("GROUP_ID_CONFIG", value);
                        setGroupId(value);
                    } else if (valueLabel === t("LBL_CLIENT_ID_CONFIG")) {
                        onInputChange("CLIENT_ID_CONFIG", value);
                        setClientId(value);
                    } else if (valueLabel === t("LBL_MAX_POLL_RECORDS_CONFIG")) {
                        onInputChange("MAX_POLL_RECORDS_CONFIG", value);
                        setPollRecords(value);
                    } else if (valueLabel === t("LBL_TIMEOUT")) {
                        const numericValue = value.replace(/\D/g, '');
                        if (numericValue.length <= 9) {
                            onInputChange("TIMEOUT", numericValue);
                            setOutTime(numericValue);
                        }
                    } else if (valueLabel === t("LBL_USERNAME")) {
                        onInputChange("USERNAME", value);
                        setUsername(value);
                    } else if (valueLabel === t("LBL_WS_PASSWORD")) {
                        onInputChange("PASSWORD", value);
                        setPassword(value);
                    } else if (valueLabel === t("LBL_KEYSTORE")) {
                        onInputChange("KEYSTORE", value);
                        setKeyStore(value);
                    } else if (valueLabel === t("LBL_KEYSTORE_PASSWORD")) {
                        onInputChange("KEYSTORE_PWD", value);
                        setKeyStorePassword(value);
                    } else if (valueLabel === t("LBL_KEY_PASSWORD")) {
                        onInputChange("KEY_PWD", value);
                        setKeyPassword(value);
                    } else if (valueLabel === t("TRUSTSTORE")) {
                        onInputChange("TRUSTSTORE", value);
                        setTrustStore(value);
                    } else if (valueLabel === t("LBL_TRUSTSTORE_PASSWORD")) {
                        onInputChange("TRUSTSTORE_PWD", value);
                        settrustStorePassword(value);
                    }
                }}
                inputType={
                    valueLabel === t("LBL_WS_PASSWORD") || 
                    valueLabel === t("LBL_KEYSTORE_PASSWORD") || 
                    valueLabel === t("LBL_KEY_PASSWORD") || 
                    valueLabel === t("LBL_TRUSTSTORE_PASSWORD") 
                    ? "password" : "text"
                }
                specialPasswordField={
                    valueLabel === t("LBL_WS_PASSWORD") || 
                    valueLabel === t("LBL_KEYSTORE_PASSWORD") || 
                    valueLabel === t("LBL_KEY_PASSWORD") || 
                    valueLabel === t("LBL_TRUSTSTORE_PASSWORD")
                }
            />
            <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
                <Alert
                    onClose={() => handleAlertClose()}
                    severity={showAlert.type}
                    variant="filled"
                    sx={{ width: "100%" }}>
                    {showAlert.mssg}
                </Alert>
            </Snackbar>
        </>
    )
}

export default Kafka